export default "__VITE_ASSET__B$5WDV$j__"